<template>
    <router-view></router-view>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
    data() {
        return {
            model: {
            },

        };
    },
    created() {
        this.getMyCompany("mine");
    },
    methods: {
        ...mapActions('my-company', {
            getMyCompany: 'get',
        }),
    },
    computed: {

    },
}
</script>
